import { render, staticRenderFns } from "./userAdministration.vue?vue&type=template&id=917c0184&scoped=true&"
import script from "./userAdministration.vue?vue&type=script&lang=js&"
export * from "./userAdministration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "917c0184",
  null
  
)

export default component.exports